package feature.businessType.repository

import feature.businessType.model.BusinessType
import kotlinx.coroutines.flow.MutableStateFlow

class BusinessTypeRepository {
    val allBusinessTypeLiveData: MutableStateFlow<List<BusinessType>> = MutableStateFlow(
        arrayListOf()
    )
    var businessType: BusinessType? = null
}